import React from "react";
import NewsCard from "../News/NewsCard";
import NewsCategoryTitle from "../NewsCategory/NewsCategoryTitle";
import { useSelector } from "react-redux";
import { withTranslation } from 'react-i18next';

const Layout12 = ({ titleColor, data, name, logo, props, analyticsInfo }) => {

  const isPreview = useSelector(state => state.info.isPreview);
  const warningOn = data.length < 7 ? true : false;
  const { t } = props;

  return data ? (
    <div>
      <NewsCategoryTitle
        props={props}
        isFixedLayout={false}
        titleColor={titleColor}
        name={name}
        analyticsInfo={analyticsInfo}
        logo={logo}
      />
      {isPreview && warningOn &&
        <div class="alert alert-warning pl-3">
          <strong>{t("errors.warning")}</strong> {t("errors.insuficientContent")}
        </div>
      }
      {data.length > 0 ?
        <div className="row pl-3">
          <div className="col-12 col-md-3 pl-0">
            {data.slice(0, 2).map((card, index) => (
              <NewsCard
                id={card?.id}
                key={index}
                type="card"
                icon={card?.fields?.has_video ? "video_icon" : "link_icon"}
                key={index}
                cardSize="card_news three_row_news"
                cardinfo={card}
                image={card?.fields?.cover_image?.directURLArray.medium}
                imageClass={card?.fields?.image_alignment}
                createdDate={
                  card?.fields?.authoring_date?.value
                }
                summary={card?.fields?.title}
                tagList={card?.fields?.tags_list}
                analyticsInfo={analyticsInfo}
              />
            ))}
          </div>

          <div className="col-12 col-md-3 pl-0">
            {data.slice(2, 4).map((card, index) => (
              <NewsCard
                id={card?.id}
                key={index}
                type="card"
                icon={card?.fields?.has_video ? "video_icon" : "link_icon"}
                key={index}
                cardSize="card_news three_row_news"
                cardinfo={card}
                image={card?.fields?.cover_image?.directURLArray.medium}
                imageClass={card?.fields?.image_alignment}
                createdDate={
                  card?.fields?.authoring_date?.value
                }
                summary={card?.fields?.title}
                tagList={card?.fields?.tags_list}
                analyticsInfo={analyticsInfo}
              />
            ))}
          </div>

          <div className="col-12 col-md-3 pl-0">
            {data.slice(4, 6).map((card, index) => (
              <NewsCard
                id={card?.id}
                key={index}
                type="card"
                icon={card?.fields?.has_video ? "video_icon" : "link_icon"}
                key={index}
                cardSize="card_news three_row_news"
                cardinfo={card}
                image={card?.fields?.cover_image?.directURLArray.medium}
                imageClass={card?.fields?.image_alignment}
                createdDate={
                  card?.fields?.authoring_date?.value
                }
                summary={card?.fields?.title}
                tagList={card?.fields?.tags_list}
                analyticsInfo={analyticsInfo}
              />
            ))}
          </div>

          <div className="col-12 col-md-3 pl-0">
            <NewsCard
              id={data[6]?.id}
              type="card"
              icon={data[6]?.fields?.has_video ? "video_icon" : "link_icon"}
              cardSize="card_news one_col_news"
              cardinfo={data[6]}
              image={data[6]?.fields?.cover_image?.directURLArray.medium}
              imageClass={data[6]?.fields?.image_alignment}
              createdDate={
                data[6]?.fields?.authoring_date?.value
              }
              summary={data[6]?.fields?.title}
              tagList={data[6]?.fields?.tags_list}
              analyticsInfo={analyticsInfo}
            />
          </div>
        </div>
        : null}
    </div>
  ) : null;
};

export default withTranslation()(Layout12);
